/**
 * Tenant-slug resolver — lives in its own module so both `lib/api.js` and
 * `lib/tokenStore.js` can import it without creating a circular dep.
 *
 * Order of precedence:
 *   1. localStorage `kb_tenant` (admin/dev override)
 *   2. URL path prefix `/t/{slug}/...`
 *   3. Subdomain (production custom domains only)
 *   4. fallback "default"
 */
export function resolveTenantSlug() {
  try {
    const ls = localStorage.getItem("kb_tenant");
    if (ls && ls !== "default") return ls;
  } catch { /* SSR / private mode */ }
  if (typeof window !== "undefined") {
    const parts = window.location.pathname.split("/").filter(Boolean);
    if (parts[0] === "t" && parts[1]) return parts[1];
    const host = window.location.hostname || "";
    if (host.split(".").length >= 3) {
      const sub = host.split(".")[0];
      if (!["www", "preview", "fashion-collective-18"].includes(sub)) return sub;
    }
  }
  return "default";
}
